var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "90px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "店铺名称" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入门店名称",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.storeName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "storeName", $$v)
                                },
                                expression: "listPram.storeName",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.storeType
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "归属商家" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth ",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.handleSelectedList },
                                  model: {
                                    value: _vm.listPram.offlineSupplierId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.listPram,
                                        "offlineSupplierId",
                                        $$v
                                      )
                                    },
                                    expression: "listPram.offlineSupplierId",
                                  },
                                },
                                _vm._l(_vm.formStoreSelect, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.supplierName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "status", $$v)
                                },
                                expression: "listPram.status",
                              },
                            },
                            _vm._l(_vm.offsetStateOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "核销方式" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.writeOffType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "writeOffType", $$v)
                                },
                                expression: "listPram.writeOffType",
                              },
                            },
                            _vm._l(_vm.verificationOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "数据来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { placeholder: "请选择", disabled: "" },
                              model: {
                                value: _vm.listPram.editType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "editType", $$v)
                                },
                                expression: "listPram.editType",
                              },
                            },
                            _vm._l(_vm.editTypeOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "mr20",
                          attrs: { type: "primary" },
                          on: { click: _vm.handerSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "mr20",
                          attrs: { type: "primary" },
                          on: { click: _vm.handleAddStore },
                        },
                        [_vm._v("添加店铺")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "mr20",
                          attrs: { type: "primary" },
                          on: { click: _vm.handleOpenDolaPopup },
                        },
                        [_vm._v("导入店铺")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "门店名称",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeAddress",
                  label: "门店地址",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.regionName || "") +
                              _vm._s(scope.row.storeAddress || "")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "statusName",
                  label: "门店状态",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "核销方式", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.getVerificationMethodName(
                                scope.row.writeOffType
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "systemAdminsName",
                  label: "管理员姓名",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "数据来源", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.getEditTypeName(scope.row.editType)) +
                            "\n\t\t\t\t\t"
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "externalId",
                  label: "三方店铺ID",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "80",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetailEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openNavgetToUsers(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看员工")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.offlineStoreDelete(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.titleType ? "添加店铺" : "修改店铺",
                visible: _vm.dialogVisible,
                "close-on-click-modal": _vm.showPopup,
                width: "50%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
                close: _vm.closedialog,
                opened: _vm.handleDialogOpened,
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.form,
                    "label-width": "80px",
                  },
                },
                [
                  _vm.storeType
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "所属商家" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择供应商或客户" },
                              on: { change: _vm.handleSelectedList },
                              model: {
                                value: _vm.form.offlineSupplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "offlineSupplierId", $$v)
                                },
                                expression: "form.offlineSupplierId",
                              },
                            },
                            _vm._l(_vm.formStoreSelect, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.supplierName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "门店名称", prop: "storeName" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: _vm.isDisabled },
                        model: {
                          value: _vm.form.storeName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "storeName", $$v)
                          },
                          expression: "form.storeName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "三方店铺ID" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入三方店铺ID",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.externalId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "externalId", $$v)
                          },
                          expression: "form.externalId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("StoreAddressPicker", {
                    ref: "addressPicker",
                    attrs: {
                      region: _vm.locationData.region,
                      "store-address": _vm.locationData.storeAddress,
                      longitude: _vm.locationData.longitude,
                      latitude: _vm.locationData.latitude,
                      "area-options": _vm.areaOptions,
                      disabled: _vm.isDisabled,
                      active: _vm.dialogVisible,
                    },
                    on: {
                      "update:region": function ($event) {
                        return _vm.$set(_vm.locationData, "region", $event)
                      },
                      "update:storeAddress": function ($event) {
                        return _vm.$set(
                          _vm.locationData,
                          "storeAddress",
                          $event
                        )
                      },
                      "update:store-address": function ($event) {
                        return _vm.$set(
                          _vm.locationData,
                          "storeAddress",
                          $event
                        )
                      },
                      "update:longitude": function ($event) {
                        return _vm.$set(_vm.locationData, "longitude", $event)
                      },
                      "update:latitude": function ($event) {
                        return _vm.$set(_vm.locationData, "latitude", $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "门店状态", prop: "status" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.isDisabled },
                          model: {
                            value: _vm.form.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status",
                          },
                        },
                        _vm._l(_vm.offsetStateOption, function (rad) {
                          return _c(
                            "el-radio",
                            { key: rad.value, attrs: { label: rad.value } },
                            [_vm._v(_vm._s(rad.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "数据来源", prop: "editType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.form.editType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "editType", $$v)
                            },
                            expression: "form.editType",
                          },
                        },
                        _vm._l(_vm.editTypeOption, function (item) {
                          return _c(
                            "el-radio",
                            { key: item.value, attrs: { label: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "核销方式", prop: "writeOffType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.writeOffType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "writeOffType", $$v)
                            },
                            expression: "form.writeOffType",
                          },
                        },
                        _vm._l(_vm.verificationOption, function (rad) {
                          return _c(
                            "el-radio",
                            { key: rad.value, attrs: { label: rad.value } },
                            [_vm._v(_vm._s(rad.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "店铺头像" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-demo",
                            attrs: {
                              action: "",
                              "http-request": _vm.handleUploadForm,
                              headers: _vm.myHeaders,
                              "show-file-list": false,
                              multiple: "",
                            },
                          },
                          [
                            _vm.urlImage
                              ? _c("img", {
                                  staticStyle: {
                                    width: "70px",
                                    height: "70px",
                                  },
                                  attrs: { src: _vm.form.avatar },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.urlImage
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "mr10",
                                    attrs: { type: "primary" },
                                  },
                                  [_vm._v("上传图片" + _vm._s())]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "管理员" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { multiple: "", placeholder: "请选择管理员" },
                          model: {
                            value: _vm.form.systemAdmins,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "systemAdmins", $$v)
                            },
                            expression: "form.systemAdmins",
                          },
                        },
                        _vm._l(_vm.formStoreSelectedOne, function (item) {
                          return _c("el-option", {
                            key: item.phone,
                            attrs: { label: item.realName, value: item.phone },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "归属员工" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { multiple: "", placeholder: "请选择员工" },
                          model: {
                            value: _vm.form.systemEmployees,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "systemEmployees", $$v)
                            },
                            expression: "form.systemEmployees",
                          },
                        },
                        _vm._l(_vm.formStoreSelectedOne, function (item) {
                          return _c("el-option", {
                            key: item.phone,
                            attrs: { label: item.realName, value: item.phone },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmitEdit },
                        },
                        [_vm._v("确定")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = _vm.fasle
                            },
                          },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "导入添加门店",
                visible: _vm.dialogAddVisible,
                width: "35%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogAddVisible = $event
                },
                close: _vm.closedialog,
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "80px" },
                },
                [
                  _c("el-form-item", { attrs: { label: "上传文件" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "ButtonUploadExcel",
                          {
                            attrs: {
                              beforeUpload: function (file) {
                                return _vm.beforeUpload(file)
                              },
                            },
                          },
                          [_vm._v("上传文件")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "20px" },
                            attrs: { type: "success" },
                            on: { click: _vm.addDowExcel },
                          },
                          [_vm._v("下载模板")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "上传说明" } }, [
                    _c("div", [_vm._v("支持文件：.xlsx .xls .csv")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "导入的文件需包含字段：门店名称,供应商ID（商户账号不传）,门店地址（ID逗号分隔）,管理员（逗号分隔）,归属员工ID（逗号分隔）,门店状态（1:已开业 2:筹备中 -1:停用）,区域名称,经度,纬度"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "导入信息" } }, [
                    _c("div", {
                      staticStyle: { color: "red" },
                      domProps: { innerHTML: _vm._s(_vm.dowCoExcleText) },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialogAddVisible = _vm.fasle
                            },
                          },
                        },
                        [_vm._v("关闭")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }